'use client';

import { cx } from '@mage-ui/styled-system/css';
import {
	button,
	cartSummary,
	flexWrapper,
	gridCol,
	gridRow,
	text,
	title,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { useContext } from 'react';
import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { GridCol } from '@/components/ui/layouts/grids/GridCol';
import { GridRow } from '@/components/ui/layouts/grids/GridRow';

export const CartSummary = ({ data, startSlot }) => {
	const { st } = useContext(StaticTextContext);
	return (
		<div className={cartSummary().root} aria-live='polite'>
			<GridRow
				className={gridRow({
					gap: 'gap100',
					gapM: 'gap500',
					gapL: 'gap500',
				})}
			>
				{startSlot && (
					<GridCol
						className={gridCol({
							colSpanM: '6',
							colSpanL: '6',
							vAlign: 'center',
						})}
					>
						{startSlot}
					</GridCol>
				)}
				<GridCol
					className={gridCol({
						colStartM: '7',
						colSpanM: '6',
						colStartL: '7',
						colSpanL: '6',
						hAlignM: 'end',
						hAlignL: 'end',
					})}
				>
					<div
						className={flexWrapper({
							direction: 'column',
							directionM: 'row',
							directionL: 'row',
							align: 'end',
							alignM: 'center',
							alignL: 'center',
							gap: 'gap400',
						})}
					>
						<dl className={flexWrapper({ align: 'center', gap: 'gap400' })}>
							<dt className={text({ size: '3' })}>{st('cart.total')}</dt>
							<dd className={cx(title({ size: '5' }), cartSummary().title)}>
								{data?.price}
							</dd>
						</dl>
						<Link href={data.summaryLink} className={button({ size: 'l' })}>
							{st('cart.continue')}
						</Link>
					</div>
				</GridCol>
			</GridRow>
		</div>
	);
};
